<template>
  <section class="blogs-articles-section pt-120 pb-100">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-8">
          <div class="section-title text-center mb-70">
            <h2>{{ content.header.title }}</h2>
            <p>{{ content.header.description }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 col-md-6 h-auto" v-for="(article, index) in content.articles" :key="index">
          <div class="blog-item h-100">
            <div class="blog-image">
              <img :src="article.image" :alt="article.title" />
              <div class="blog-date">
                <span class="day">{{ article.date.day }}</span>
                <span class="month">{{ article.date.month }}</span>
              </div>
            </div>
            <div class="blog-content">
              <div class="blog-meta">
                <span class="category">{{ article.category }}</span>
                <span class="author">By {{ article.author }}</span>
              </div>
              <h3>
                <a href="#">{{ article.title }}</a>
              </h3>
              <p>{{ article.excerpt }}</p>
             
            </div>
          </div>
        </div>
      </div>

     
    </div>
  </section>
</template>

<script>
export default {
  name: 'TechItsBlogsArticlesComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url("https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");

/* Blogs & Articles Section */
.blogs-articles-section {
  position: relative;
  z-index: 1;
  padding-top: 120px;
  padding-bottom: 100px;
  background: #fff;
}

.section-title {
  margin-bottom: 70px;
}

.section-title h2 {
  font-size: 40px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 20px;
  font-family: "Archivo", sans-serif;
}

.section-title p {
  font-size: 16px;
  color: #6c757d;
  line-height: 1.8;
}

.section-title.text-center {
  text-align: center;
}

.blog-item {
  background: #fff;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  margin-bottom: 30px;
  border: 1px solid rgba(246, 236, 79, 0.2);
}

.blog-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  border-color: #f6ec4f;
}

.blog-image {
  position: relative;
  overflow: hidden;
}

.blog-image img {
  width: 100%;
  height: 250px;
  object-fit: cover;
  transition: all 0.3s ease;
}

.blog-item:hover .blog-image img {
  transform: scale(1.05);
}

.blog-date {
  position: absolute;
  top: 20px;
  left: 20px;
  background: #f6ec4f;
  color: #2c3e50;
  padding: 10px 15px;
  border-radius: 8px;
  text-align: center;
  font-weight: 600;
}

.blog-date .day {
  display: block;
  font-size: 20px;
  line-height: 1;
}

.blog-date .month {
  display: block;
  font-size: 12px;
  text-transform: uppercase;
}

.blog-content {
  padding: 30px;
}

.blog-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  font-size: 14px;
}

.blog-meta .category {
  background: rgba(246, 236, 79, 0.2);
  color: #2c3e50;
  padding: 5px 12px;
  border-radius: 15px;
  font-weight: 500;
}

.blog-meta .author {
  color: #6c757d;
}

.blog-content h3 {
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 15px;
  line-height: 1.4;
  font-family: "Archivo", sans-serif;
}

.blog-content h3 a {
  color: inherit;
  text-decoration: none;
  transition: color 0.3s ease;
}

.blog-content h3 a:hover {
  color: #f6ec4f;
}

.blog-content p {
  color: #6c757d;
  line-height: 1.6;
  margin-bottom: 20px;
}

.read-more {
  color: #f6ec4f;
  text-decoration: none;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.read-more:hover {
  color: #2c3e50;
  gap: 12px;
}

.btn {
  display: inline-block;
  padding: 15px 30px;
  background: #f6ec4f;
  color: #2c3e50;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
}

.btn:hover {
  background: #2c3e50;
  color: #f6ec4f;
  transform: translateY(-2px);
}

.btn i {
  margin-left: 8px;
  transition: transform 0.3s ease;
}

.btn:hover i {
  transform: translateX(4px);
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .blogs-articles-section {
    padding: 80px 0;
  }
}

@media only screen and (max-width: 767px) {
  .blogs-articles-section {
    padding: 60px 0;
  }
  
  .section-title h2 {
    font-size: 32px;
  }
  
  .blog-content {
    padding: 25px;
  }
  
  .blog-content h3 {
    font-size: 18px;
  }
  
  .blog-image img {
    height: 200px;
  }
}

@media only screen and (max-width: 399px) {
  .blogs-articles-section {
    padding: 40px 0;
  }
  
  .section-title h2 {
    font-size: 28px;
  }
  
  .blog-content {
    padding: 20px;
  }
}
</style>
